(function(itxApp) {

    'use strict';

    var itxPopupLayoutCmp = {
        controllerAs: '$ctrl',
        templateUrl: 'itxPopupLayoutCmpTpl.html',
        controller: itxPopupLayoutCmpCtrl,
        bindings: {
            data: '<'
        }
    };

    itxPopupLayoutCmpCtrl.$inject = ['$scope'];

    function itxPopupLayoutCmpCtrl($scope) {

        this.pathMedia = window.staticContent + '/media/2017/popup_marketing/' + this.data.popup_suscripcion_20;
        $scope.formNewsletter = false;
        $scope.coverImg = false;

        switch (this.data.popup_suscripcion_2) {
            case 'image-form-express':
                this.data.popup_suscripcion_4 = '';
                this.data.popup_suscripcion_5 = '';
                this.data.popup_suscripcion_6 = '';
                this.data.popup_suscripcion_7 = '';
                this.dataJson = this.data;
                $scope.bgCoverImg = { 'background-image': 'url(' + this.pathMedia + ')' };
                $scope.formNewsletter = true;
                break;
            case 'form-express':
                this.data.popup_suscripcion_4 = '';
                this.data.popup_suscripcion_5 = '';
                this.data.popup_suscripcion_6 = '';
                this.data.popup_suscripcion_7 = '';
                this.dataJson = this.data;
                $scope.bgCoverImg = false;
                $scope.formNewsletter = true;
                break;

            case 'image-text':
                this.dataJson = this.data;
                $scope.bgCoverImg = { 'background-image': 'url(' + this.pathMedia + ')' };
                $scope.coverImg = true;
                break;

            case 'image-text-full':
                this.dataJson = this.data;
                $scope.bgCoverImg = { 'background-image': 'url(' + this.pathMedia + ')' };
                $scope.coverImg = true;
                break;
        }

    }

    angular.module('itxApp.common')
        .component('itxPopupLayout', itxPopupLayoutCmp);

    itxApp.common.itxPopupLayoutCmp = itxPopupLayoutCmp;
    itxApp.common.itxPopupLayoutCmpCtrl = itxPopupLayoutCmpCtrl;

})(window.itxApp);